// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export const BusinessRejectError = {
    NEW_PASS_EMPTY: 203,
    USER_NOT_FOUND: 482,
    MAX_TRADING_WEBHOOK_KEYS_REACHED: 505
};
export const BusinessRejectErrorDictionary = {
    2: 'BusinessRejectMessage.2',
    419: 'BusinessRejectMessage.419',
    417: 'Resources.Property.Opening market orders are forbidden',
    103: 'reports.Order TIF is forbidden by trade session',
    [BusinessRejectError.NEW_PASS_EMPTY]: 'BusinessRejectMessage.203',
    371: 'Session has expired. Please login.',
    432: 'Product request cannot be processed.',
    433: 'The total limit of alerts has been reached.',
    434: 'Alert cannot be created due to wrong node.',
    435: 'Bid/Ask prices are not available for the instrument.',
    436: 'Product subscription failure: Unable to subscribe because there are no active accounts for charging on product.',
    437: 'Product subscription failure: Not enough balance to pay fee.',
    446: 'Product is no longer relevant for use',
    453: 'BusinessRejectMessage.453',
    [BusinessRejectError.USER_NOT_FOUND]: 'BusinessRejectMessage.482',
    483: 'BusinessRejectMessage.483',
    484: 'BusinessRejectMessage.484',
    [BusinessRejectError.MAX_TRADING_WEBHOOK_KEYS_REACHED]: 'BusinessRejectMessage.MaxTradingWebhookKeysReached',
    120: 'BusinessRejectMessage.120'
    // "Alert has not been created, the maximum number of alerts for the user has been reached."  //ожидаю код id:99971
};
export const BusinessRejectTextCodeDict = {
    'RiskManagement.Messages.WeeklyLimit': 1001,
    'RiskManagement.Messages.MaxTrailingLimit': 1002,
    'RiskManagement.Messages.DailyLimit': 1003,
    'RiskManagement.Messages.MaxUnrealizedLossLimit': 1004,
    'RiskManagement.Messages.MaxDailyProfit': 1005,
    'RiskManagement.Messages.MaxOrdersCountPerDay': 1006,
    'RiskManagement.Messages.MaxRelativeDrawDownLevel': 1007,
    'RiskManagement.Messages.EODTrailingDrawDownLevel': 1008,
    'RiskManagement.Messages.RelativeDailyLossLimit': 1009
};
export const BusinessRejectMessagesKey = {
    WeeklyLimit: 'RiskManagement.Messages.WeeklyLimit',
    MaxTrailingLimit: 'RiskManagement.Messages.MaxTrailingLimit',
    DailyLimit: 'RiskManagement.Messages.DailyLimit',
    MaxUnrealizedLossLimit: 'RiskManagement.Messages.MaxUnrealizedLossLimit',
    MaxDailyProfit: 'RiskManagement.Messages.MaxDailyProfit',
    MaxOrdersCountPerDay: 'RiskManagement.Messages.MaxOrdersCountPerDay',
    MaxRelativeDrawDownLevel: 'RiskManagement.Messages.MaxRelativeDrawDownLevel',
    EODTrailingDrawDownLevel: 'RiskManagement.Messages.EODTrailingDrawDownLevel',
    RelativeDailyLossLimit: 'RiskManagement.Messages.RelativeDailyLossLimit'
};
